import React from 'react';
import { useDashboard } from '../../context/DashboardContext';

const HelpModal = () => {
  const { showHelpModal, setShowHelpModal } = useDashboard();

  if (!showHelpModal) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={() => setShowHelpModal(false)}>
      <div className="modal-box help-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ marginBottom: '1.5rem', color: '#2c3e50' }}>How to Use This Dashboard</h3>
        
        <div style={{ fontSize: '0.9rem', lineHeight: 1.7, color: '#333' }}>
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>Home View:</strong> Browse and select a city from the carousel to begin analysis.
            </li>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>Summary View:</strong> View impact cards organized by category. Each card shows indicator status breakdowns and allows you to explore available metrics.
            </li>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>Detail View:</strong> Explore interactive maps and trend charts for selected indicators. Click on wards in the map to view ward-specific data. Use breadcrumbs to navigate back to previous views.
            </li>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>From Summary View:</strong> Click any colored indicator tag within an impact card to view detailed maps and trends for that indicator.
            </li>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>Impact Ranking:</strong> Customize the priority order of impact cards by opening the Settings modal (⚙️ Settings button in header). In the Priority tab, drag and drop impact cards to reorder them according to your priorities. The new order will be saved and applied to the Summary View.
            </li>
            <li style={{ marginBottom: '0.5rem', textAlign: 'justify' }}>
              <strong>Severity Thresholds:</strong> Adjust severity thresholds for indicators in the Settings modal (⚙️ Settings button in header). In the Threshold tab, modify threshold values for each indicator to control when indicators are classified as Low, Medium, High, or Critical severity levels. Changes will recalculate severity classifications across the dashboard.
            </li>
          </ul>
        </div>

        <button className="modal-close" onClick={() => setShowHelpModal(false)} style={{ marginTop: '1.5rem' }}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default HelpModal;

